<template>
  <div class="wp_productReviewModalContainer">
    <div
      class="col-12 pr-0 mr-0"
      v-if="review.image_urls.length"
    >
      <div class="review-images-wrapper">
        <div
          class="wp_userReviewImage"
          v-for="(url,key) in review.image_urls"
          :key="'review-'+ key"
          :id="'review-images-'+ key"
        >
          <a
            href
            style="widows: 100; height: 100%;"
            data-toggle="modal"
            :id="'review-images-link-imageLightBoxLink-'+ key"
            @click="modalopen(key)"
												:data-test="'imageLightBoxLink'+key"
          >
            <img
              class
              :src="url"
              alt="Review Image"
														:data-test="'imageLightBoxImg'+key"
														:id="'imageLightBoxImg'+key"
            >
          </a>
        </div>
      </div>
    </div>
    <!-- Modal -->

			<review-mobile-modal
				:review="review"
				:productId="productId"
				:imageSelected="imageSelected"
				:index="index"
				@closeMobileReviewModal="closemodal($event)"
				@commentReview="commentReview($event)"
				v-if="showMobileReviewModal"
			/>

    <!-- desktop -->
			<review-desktop-modal
				:review="review"
				:productId="productId"
				:index="index"
				@commentReview="commentReview($event)"
				v-if="showMobileReviewModal"
			/>
    <!-- desktop -->
  </div>
</template>

<script>
import ReviewMobileModal from '@/components/pages/productDetails/widgets/ReviewMobileModal'
import ReviewDesktopModal from '@/components/pages/productDetails/widgets/ReviewDesktopModal'
// import ReviewFooter from '@/components/pages/productDetails/sections/ReviewFooter'
// import ImageSlider from '@/components/shared/ImageSlider'
import { fullScreenImageModal } from '../../../../commonJs/FullScreenImageModal'

export default {
	name: 'review-image-lightbox',
	props: {
		review: {},
		productId: null,
		index: {
			default: 0,
			type: Number
		}
	},
	components: {
		// ReviewFooter,
		// ImageSlider,
		ReviewMobileModal,
		ReviewDesktopModal
	},
	data () {
		return {
			imageSelected: 0,
			showMobileReviewModal: false
		}
	},
	methods: {
		closemodal (e) {
			this.showMobileReviewModal = false
			fullScreenImageModal.closeModal(e, '-review-', this.index)
			fullScreenImageModal.closeModal(e, '-product-image-slider-', this.index)

			// document.querySelector('.reviewmodalclose').closest('.nice-modal').classList.remove('open');
		},
		modalopen () {
			this.showMobileReviewModal = true
			setTimeout(() => {
				fullScreenImageModal.modalOpen(screen.width, '-review-', this.index)
			}, 50)
			// document.querySelector('.reviewmodalclose').closest('.nice-modal').classList.add('open');
		},
		commentReview (productId) {
			this.$emit('commentReview', productId)
		}
	},
	mounted () {
		$('.owl-carousel').owlCarousel({
			loop: true,
			margin: 10,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
					nav: false
				},
				600: {
					items: 1,
					nav: false
				},
				1000: {
					items: 1,
					nav: false,
					loop: false
				}
			}
		})
	}
}
</script>

<style scoped>
</style>
